(function() { window.GUID_d56cf2ca_8590_4e34_9737_930e0db8d263 = { getGuid: function() { return "d56cf2ca-8590-4e34-9737-930e0db8d263"; } }; })();
/** Initial values of the score sheet finder state. */
class ScoreSheetFinderState {
    constructor() { }
    static get initialFilters() {
        return {
            ids: {
                name: "ids",
                value: undefined,
            },
            eventId: {
                name: "eventId",
                value: undefined,
            },
            opponentType: {
                name: "opponentType",
                value: undefined,
            },
            NbPlayers: {
                name: "NbPlayers",
                value: undefined,
            },
            NbGames: {
                name: "NbGames",
                value: undefined,
            },
            NbRounds: {
                name: "NbRounds",
                value: undefined,
            },
            rotations: {
                name: "rotations",
                value: undefined,
            },
            advancedFilters: {
                name: "advancedFilters",
                value: undefined,
            },
            format: {
                name: "format",
                value: "list",
            },
            IsUserTemplate: {
                name: "IsUserTemplate",
                value: undefined,
            },
            IsForSingles: {
                name: "IsForSingles",
                value: undefined,
            },
            HasDoubles: {
                name: "HasDoubles",
                value: undefined,
            },
            HasBreakLabels: {
                name: "HasBreakLabels",
                value: undefined,
            },
            HasWinBoxes: {
                name: "HasWinBoxes",
                value: undefined,
            },
            HasHandicap: {
                name: "HasHandicap",
                value: undefined,
            },
            HasFlawlessBox: {
                name: "HasFlawlessBox",
                value: undefined,
            },
            HasFlawlessList: {
                name: "HasFlawlessList",
                value: undefined,
            },
            HasMoney: {
                name: "HasMoney",
                value: undefined,
            },
            HasRoundPointModifier: {
                name: "HasRoundPointModifier",
                value: undefined,
            },
            HasTotalScoreModifier: {
                name: "HasTotalScoreModifier",
                value: undefined,
            },
            Has8Ball: {
                name: "Has8Ball",
                value: undefined,
            },
            Has9Ball: {
                name: "Has9Ball",
                value: undefined,
            },
            Has10Ball: {
                name: "Has10Ball",
                value: undefined,
            },
            HasInnings: {
                name: "HasInnings",
                value: undefined,
            },
            HasSpecial: {
                name: "HasSpecial",
                value: undefined,
            },
            HasPlayerRepeater: {
                name: "HasPlayerRepeater",
                value: undefined,
            },
            IsVertical: {
                name: "IsVertical",
                value: undefined,
            },
            HasTotalsForVertical: {
                name: "HasTotalsForVertical",
                value: undefined,
            },
            GameRowsAreDynamic: {
                name: "GameRowsAreDynamic",
                value: undefined,
            },
        };
    }
    static get initialColumnFilters() {
        return {
            Title: undefined,
        };
    }
}

//# sourceMappingURL=ScoreSheetFinderState.js.map
